import { getRuntime, runtimeKeys } from '@codametrix/client-runtime';

/**
 * When FRONTEND_SESSION_FIRST is on (same flag as isSessionRenewEnabled),
 * browser API calls rely on the session cookie — do not attach Authorization.
 */
export function shouldAttachBearerAuthorization(): boolean {
  return getRuntime().flag(runtimeKeys.FRONTEND_SESSION_FIRST) !== true;
}
